import React, { useRef, useEffect } from "react";

import cardBuilder from "../utils/cardBuilder";

function CardCanvas(props) {
	const bgCanvasRef = useRef(null);

	useEffect(() => {
		const canvas = bgCanvasRef.current;
		const context = canvas.getContext("2d");
		const cardX = props.addBleedBorder ? 36 : 0;
		const cardY = props.addBleedBorder ? 36 : 0;
		const cardWidth = 750;
		const cardHeight = 1050;
		if(props.addBleedBorder){
			context.fillStyle = "#000000";
			context.fillRect(0,0,props.width,props.height);
		}
		//context.clearRect(0, 0, props.width, props.height);
		//context.clearRect(cardX, cardY, cardWidth, cardHeight);
		cardBuilder(props).then((img) => {
			const cardImg = document.createElement("img");
			cardImg.src = img;
			cardImg.onload = () => {
				context.drawImage(cardImg, cardX, cardY, cardWidth, cardHeight);
			};
		});
	}, [props]);

	return (
		<div className="card">
			<canvas ref={bgCanvasRef} width={props.width} height={props.height} />
		</div>
	);
}

export default CardCanvas;
